var exports = {
  "container": "xfd349460--e8236c--container",
  "price-diff": "xfd349460--e8236c--price-diff",
  "price-diff--red": "xfd349460--e8236c--price-diff--red",
  "price-diff--green": "xfd349460--e8236c--price-diff--green",
};

module.exports = exports;
